/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppPricingRouteImport } from './routes/_app/pricing'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppAnalysisRouteImport } from './routes/_app/analysis'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports/index'
import { Route as AppInventoryIndexRouteImport } from './routes/_app/inventory/index'
import { Route as AppCatalogIndexRouteImport } from './routes/_app/catalog/index'
import { Route as AppWorkforcePayrollRouteImport } from './routes/_app/workforce/payroll'
import { Route as AppWorkforceEmployeesRouteImport } from './routes/_app/workforce/employees'
import { Route as AppWorkforceAttendanceRouteImport } from './routes/_app/workforce/attendance'
import { Route as AppSettingsUnitsRouteImport } from './routes/_app/settings/units'
import { Route as AppSettingsTaxRatesRouteImport } from './routes/_app/settings/tax-rates'
import { Route as AppSettingsOpeningBalancesRouteImport } from './routes/_app/settings/opening-balances'
import { Route as AppSettingsMasterDataRouteImport } from './routes/_app/settings/master-data'
import { Route as AppSettingsImportExportRouteImport } from './routes/_app/settings/import-export'
import { Route as AppSettingsDealerAreasRouteImport } from './routes/_app/settings/dealer-areas'
import { Route as AppSettingsCategoriesRouteImport } from './routes/_app/settings/categories'
import { Route as AppSettingsBrandsRouteImport } from './routes/_app/settings/brands'
import { Route as AppSettingsBranchesRouteImport } from './routes/_app/settings/branches'
import { Route as AppSalesReturnsRouteImport } from './routes/_app/sales/returns'
import { Route as AppSalesPaymentsRouteImport } from './routes/_app/sales/payments'
import { Route as AppSalesOrdersRouteImport } from './routes/_app/sales/orders'
import { Route as AppSalesInvoicesRouteImport } from './routes/_app/sales/invoices'
import { Route as AppSalesDeliveriesRouteImport } from './routes/_app/sales/deliveries'
import { Route as AppSalesDealersRouteImport } from './routes/_app/sales/dealers'
import { Route as AppSalesCreditNotesRouteImport } from './routes/_app/sales/credit-notes'
import { Route as AppReportsSupplierBalancesRouteImport } from './routes/_app/reports/supplier-balances'
import { Route as AppReportsProductStockSalesCostRouteImport } from './routes/_app/reports/product-stock-sales-cost'
import { Route as AppReportsPaymentExpenseLedgerRouteImport } from './routes/_app/reports/payment-expense-ledger'
import { Route as AppReportsItemSalesCostRouteImport } from './routes/_app/reports/item-sales-cost'
import { Route as AppReportsDealerStatementRouteImport } from './routes/_app/reports/dealer-statement'
import { Route as AppProductionWorkOrdersRouteImport } from './routes/_app/production/work-orders'
import { Route as AppProductionPlanningRouteImport } from './routes/_app/production/planning'
import { Route as AppProductionBomExplorerRouteImport } from './routes/_app/production/bom-explorer'
import { Route as AppPeopleUsersRouteImport } from './routes/_app/people/users'
import { Route as AppPeopleRolesRouteImport } from './routes/_app/people/roles'
import { Route as AppInventoryWarehousesRouteImport } from './routes/_app/inventory/warehouses'
import { Route as AppInventoryTransfersRouteImport } from './routes/_app/inventory/transfers'
import { Route as AppImportsSuppliersRouteImport } from './routes/_app/imports/suppliers'
import { Route as AppImportsShipmentsRouteImport } from './routes/_app/imports/shipments'
import { Route as AppImportsPurchaseOrdersRouteImport } from './routes/_app/imports/purchase-orders'
import { Route as AppImportsLcRouteImport } from './routes/_app/imports/lc'
import { Route as AppFinancePayablesRouteImport } from './routes/_app/finance/payables'
import { Route as AppFinanceLoansRouteImport } from './routes/_app/finance/loans'
import { Route as AppFinanceGlRouteImport } from './routes/_app/finance/gl'
import { Route as AppFinanceFxRouteImport } from './routes/_app/finance/fx'
import { Route as AppFinanceExpensesRouteImport } from './routes/_app/finance/expenses'
import { Route as AppFinanceAccountsRouteImport } from './routes/_app/finance/accounts'
import { Route as AppCatalogBomRouteImport } from './routes/_app/catalog/bom'
import { Route as AppWorkforceEmployeesEmployeeIdRouteImport } from './routes/_app/workforce/employees.$employeeId'
import { Route as AppSalesDealersDealerIdRouteImport } from './routes/_app/sales/dealers.$dealerId'
import { Route as AppFinanceReportsTrialBalanceRouteImport } from './routes/_app/finance/reports/trial-balance'
import { Route as AppFinanceReportsIncomeStatementRouteImport } from './routes/_app/finance/reports/income-statement'
import { Route as AppFinanceReportsCashFlowRouteImport } from './routes/_app/finance/reports/cash-flow'
import { Route as AppFinanceReportsBalanceSheetRouteImport } from './routes/_app/finance/reports/balance-sheet'
import { Route as AppFinanceReportsArAgingRouteImport } from './routes/_app/finance/reports/ar-aging'
import { Route as AppCatalogProductsProductIdRouteImport } from './routes/_app/catalog/products.$productId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppPricingRoute = AppPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalysisRoute = AppAnalysisRouteImport.update({
  id: '/analysis',
  path: '/analysis',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppReportsRoute,
} as any)
const AppInventoryIndexRoute = AppInventoryIndexRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogIndexRoute = AppCatalogIndexRouteImport.update({
  id: '/catalog/',
  path: '/catalog/',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkforcePayrollRoute = AppWorkforcePayrollRouteImport.update({
  id: '/workforce/payroll',
  path: '/workforce/payroll',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkforceEmployeesRoute = AppWorkforceEmployeesRouteImport.update({
  id: '/workforce/employees',
  path: '/workforce/employees',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkforceAttendanceRoute = AppWorkforceAttendanceRouteImport.update({
  id: '/workforce/attendance',
  path: '/workforce/attendance',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsUnitsRoute = AppSettingsUnitsRouteImport.update({
  id: '/units',
  path: '/units',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTaxRatesRoute = AppSettingsTaxRatesRouteImport.update({
  id: '/tax-rates',
  path: '/tax-rates',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsOpeningBalancesRoute =
  AppSettingsOpeningBalancesRouteImport.update({
    id: '/opening-balances',
    path: '/opening-balances',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsMasterDataRoute = AppSettingsMasterDataRouteImport.update({
  id: '/master-data',
  path: '/master-data',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsImportExportRoute = AppSettingsImportExportRouteImport.update({
  id: '/import-export',
  path: '/import-export',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDealerAreasRoute = AppSettingsDealerAreasRouteImport.update({
  id: '/dealer-areas',
  path: '/dealer-areas',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsCategoriesRoute = AppSettingsCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBrandsRoute = AppSettingsBrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBranchesRoute = AppSettingsBranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSalesReturnsRoute = AppSalesReturnsRouteImport.update({
  id: '/sales/returns',
  path: '/sales/returns',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesPaymentsRoute = AppSalesPaymentsRouteImport.update({
  id: '/sales/payments',
  path: '/sales/payments',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesOrdersRoute = AppSalesOrdersRouteImport.update({
  id: '/sales/orders',
  path: '/sales/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesInvoicesRoute = AppSalesInvoicesRouteImport.update({
  id: '/sales/invoices',
  path: '/sales/invoices',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesDeliveriesRoute = AppSalesDeliveriesRouteImport.update({
  id: '/sales/deliveries',
  path: '/sales/deliveries',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesDealersRoute = AppSalesDealersRouteImport.update({
  id: '/sales/dealers',
  path: '/sales/dealers',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesCreditNotesRoute = AppSalesCreditNotesRouteImport.update({
  id: '/sales/credit-notes',
  path: '/sales/credit-notes',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsSupplierBalancesRoute =
  AppReportsSupplierBalancesRouteImport.update({
    id: '/supplier-balances',
    path: '/supplier-balances',
    getParentRoute: () => AppReportsRoute,
  } as any)
const AppReportsProductStockSalesCostRoute =
  AppReportsProductStockSalesCostRouteImport.update({
    id: '/product-stock-sales-cost',
    path: '/product-stock-sales-cost',
    getParentRoute: () => AppReportsRoute,
  } as any)
const AppReportsPaymentExpenseLedgerRoute =
  AppReportsPaymentExpenseLedgerRouteImport.update({
    id: '/payment-expense-ledger',
    path: '/payment-expense-ledger',
    getParentRoute: () => AppReportsRoute,
  } as any)
const AppReportsItemSalesCostRoute = AppReportsItemSalesCostRouteImport.update({
  id: '/item-sales-cost',
  path: '/item-sales-cost',
  getParentRoute: () => AppReportsRoute,
} as any)
const AppReportsDealerStatementRoute =
  AppReportsDealerStatementRouteImport.update({
    id: '/dealer-statement',
    path: '/dealer-statement',
    getParentRoute: () => AppReportsRoute,
  } as any)
const AppProductionWorkOrdersRoute = AppProductionWorkOrdersRouteImport.update({
  id: '/production/work-orders',
  path: '/production/work-orders',
  getParentRoute: () => AppRoute,
} as any)
const AppProductionPlanningRoute = AppProductionPlanningRouteImport.update({
  id: '/production/planning',
  path: '/production/planning',
  getParentRoute: () => AppRoute,
} as any)
const AppProductionBomExplorerRoute =
  AppProductionBomExplorerRouteImport.update({
    id: '/production/bom-explorer',
    path: '/production/bom-explorer',
    getParentRoute: () => AppRoute,
  } as any)
const AppPeopleUsersRoute = AppPeopleUsersRouteImport.update({
  id: '/people/users',
  path: '/people/users',
  getParentRoute: () => AppRoute,
} as any)
const AppPeopleRolesRoute = AppPeopleRolesRouteImport.update({
  id: '/people/roles',
  path: '/people/roles',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryWarehousesRoute = AppInventoryWarehousesRouteImport.update({
  id: '/inventory/warehouses',
  path: '/inventory/warehouses',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryTransfersRoute = AppInventoryTransfersRouteImport.update({
  id: '/inventory/transfers',
  path: '/inventory/transfers',
  getParentRoute: () => AppRoute,
} as any)
const AppImportsSuppliersRoute = AppImportsSuppliersRouteImport.update({
  id: '/imports/suppliers',
  path: '/imports/suppliers',
  getParentRoute: () => AppRoute,
} as any)
const AppImportsShipmentsRoute = AppImportsShipmentsRouteImport.update({
  id: '/imports/shipments',
  path: '/imports/shipments',
  getParentRoute: () => AppRoute,
} as any)
const AppImportsPurchaseOrdersRoute =
  AppImportsPurchaseOrdersRouteImport.update({
    id: '/imports/purchase-orders',
    path: '/imports/purchase-orders',
    getParentRoute: () => AppRoute,
  } as any)
const AppImportsLcRoute = AppImportsLcRouteImport.update({
  id: '/imports/lc',
  path: '/imports/lc',
  getParentRoute: () => AppRoute,
} as any)
const AppFinancePayablesRoute = AppFinancePayablesRouteImport.update({
  id: '/finance/payables',
  path: '/finance/payables',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceLoansRoute = AppFinanceLoansRouteImport.update({
  id: '/finance/loans',
  path: '/finance/loans',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceGlRoute = AppFinanceGlRouteImport.update({
  id: '/finance/gl',
  path: '/finance/gl',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceFxRoute = AppFinanceFxRouteImport.update({
  id: '/finance/fx',
  path: '/finance/fx',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceExpensesRoute = AppFinanceExpensesRouteImport.update({
  id: '/finance/expenses',
  path: '/finance/expenses',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceAccountsRoute = AppFinanceAccountsRouteImport.update({
  id: '/finance/accounts',
  path: '/finance/accounts',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogBomRoute = AppCatalogBomRouteImport.update({
  id: '/catalog/bom',
  path: '/catalog/bom',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkforceEmployeesEmployeeIdRoute =
  AppWorkforceEmployeesEmployeeIdRouteImport.update({
    id: '/$employeeId',
    path: '/$employeeId',
    getParentRoute: () => AppWorkforceEmployeesRoute,
  } as any)
const AppSalesDealersDealerIdRoute = AppSalesDealersDealerIdRouteImport.update({
  id: '/$dealerId',
  path: '/$dealerId',
  getParentRoute: () => AppSalesDealersRoute,
} as any)
const AppFinanceReportsTrialBalanceRoute =
  AppFinanceReportsTrialBalanceRouteImport.update({
    id: '/finance/reports/trial-balance',
    path: '/finance/reports/trial-balance',
    getParentRoute: () => AppRoute,
  } as any)
const AppFinanceReportsIncomeStatementRoute =
  AppFinanceReportsIncomeStatementRouteImport.update({
    id: '/finance/reports/income-statement',
    path: '/finance/reports/income-statement',
    getParentRoute: () => AppRoute,
  } as any)
const AppFinanceReportsCashFlowRoute =
  AppFinanceReportsCashFlowRouteImport.update({
    id: '/finance/reports/cash-flow',
    path: '/finance/reports/cash-flow',
    getParentRoute: () => AppRoute,
  } as any)
const AppFinanceReportsBalanceSheetRoute =
  AppFinanceReportsBalanceSheetRouteImport.update({
    id: '/finance/reports/balance-sheet',
    path: '/finance/reports/balance-sheet',
    getParentRoute: () => AppRoute,
  } as any)
const AppFinanceReportsArAgingRoute =
  AppFinanceReportsArAgingRouteImport.update({
    id: '/finance/reports/ar-aging',
    path: '/finance/reports/ar-aging',
    getParentRoute: () => AppRoute,
  } as any)
const AppCatalogProductsProductIdRoute =
  AppCatalogProductsProductIdRouteImport.update({
    id: '/catalog/products/$productId',
    path: '/catalog/products/$productId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/analysis': typeof AppAnalysisRoute
  '/audit': typeof AppAuditRoute
  '/notifications': typeof AppNotificationsRoute
  '/pricing': typeof AppPricingRoute
  '/reports': typeof AppReportsRouteWithChildren
  '/settings': typeof AppSettingsRouteWithChildren
  '/catalog/bom': typeof AppCatalogBomRoute
  '/finance/accounts': typeof AppFinanceAccountsRoute
  '/finance/expenses': typeof AppFinanceExpensesRoute
  '/finance/fx': typeof AppFinanceFxRoute
  '/finance/gl': typeof AppFinanceGlRoute
  '/finance/loans': typeof AppFinanceLoansRoute
  '/finance/payables': typeof AppFinancePayablesRoute
  '/imports/lc': typeof AppImportsLcRoute
  '/imports/purchase-orders': typeof AppImportsPurchaseOrdersRoute
  '/imports/shipments': typeof AppImportsShipmentsRoute
  '/imports/suppliers': typeof AppImportsSuppliersRoute
  '/inventory/transfers': typeof AppInventoryTransfersRoute
  '/inventory/warehouses': typeof AppInventoryWarehousesRoute
  '/people/roles': typeof AppPeopleRolesRoute
  '/people/users': typeof AppPeopleUsersRoute
  '/production/bom-explorer': typeof AppProductionBomExplorerRoute
  '/production/planning': typeof AppProductionPlanningRoute
  '/production/work-orders': typeof AppProductionWorkOrdersRoute
  '/reports/dealer-statement': typeof AppReportsDealerStatementRoute
  '/reports/item-sales-cost': typeof AppReportsItemSalesCostRoute
  '/reports/payment-expense-ledger': typeof AppReportsPaymentExpenseLedgerRoute
  '/reports/product-stock-sales-cost': typeof AppReportsProductStockSalesCostRoute
  '/reports/supplier-balances': typeof AppReportsSupplierBalancesRoute
  '/sales/credit-notes': typeof AppSalesCreditNotesRoute
  '/sales/dealers': typeof AppSalesDealersRouteWithChildren
  '/sales/deliveries': typeof AppSalesDeliveriesRoute
  '/sales/invoices': typeof AppSalesInvoicesRoute
  '/sales/orders': typeof AppSalesOrdersRoute
  '/sales/payments': typeof AppSalesPaymentsRoute
  '/sales/returns': typeof AppSalesReturnsRoute
  '/settings/branches': typeof AppSettingsBranchesRoute
  '/settings/brands': typeof AppSettingsBrandsRoute
  '/settings/categories': typeof AppSettingsCategoriesRoute
  '/settings/dealer-areas': typeof AppSettingsDealerAreasRoute
  '/settings/import-export': typeof AppSettingsImportExportRoute
  '/settings/master-data': typeof AppSettingsMasterDataRoute
  '/settings/opening-balances': typeof AppSettingsOpeningBalancesRoute
  '/settings/tax-rates': typeof AppSettingsTaxRatesRoute
  '/settings/units': typeof AppSettingsUnitsRoute
  '/workforce/attendance': typeof AppWorkforceAttendanceRoute
  '/workforce/employees': typeof AppWorkforceEmployeesRouteWithChildren
  '/workforce/payroll': typeof AppWorkforcePayrollRoute
  '/catalog/': typeof AppCatalogIndexRoute
  '/inventory/': typeof AppInventoryIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/catalog/products/$productId': typeof AppCatalogProductsProductIdRoute
  '/finance/reports/ar-aging': typeof AppFinanceReportsArAgingRoute
  '/finance/reports/balance-sheet': typeof AppFinanceReportsBalanceSheetRoute
  '/finance/reports/cash-flow': typeof AppFinanceReportsCashFlowRoute
  '/finance/reports/income-statement': typeof AppFinanceReportsIncomeStatementRoute
  '/finance/reports/trial-balance': typeof AppFinanceReportsTrialBalanceRoute
  '/sales/dealers/$dealerId': typeof AppSalesDealersDealerIdRoute
  '/workforce/employees/$employeeId': typeof AppWorkforceEmployeesEmployeeIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/analysis': typeof AppAnalysisRoute
  '/audit': typeof AppAuditRoute
  '/notifications': typeof AppNotificationsRoute
  '/pricing': typeof AppPricingRoute
  '/': typeof AppIndexRoute
  '/catalog/bom': typeof AppCatalogBomRoute
  '/finance/accounts': typeof AppFinanceAccountsRoute
  '/finance/expenses': typeof AppFinanceExpensesRoute
  '/finance/fx': typeof AppFinanceFxRoute
  '/finance/gl': typeof AppFinanceGlRoute
  '/finance/loans': typeof AppFinanceLoansRoute
  '/finance/payables': typeof AppFinancePayablesRoute
  '/imports/lc': typeof AppImportsLcRoute
  '/imports/purchase-orders': typeof AppImportsPurchaseOrdersRoute
  '/imports/shipments': typeof AppImportsShipmentsRoute
  '/imports/suppliers': typeof AppImportsSuppliersRoute
  '/inventory/transfers': typeof AppInventoryTransfersRoute
  '/inventory/warehouses': typeof AppInventoryWarehousesRoute
  '/people/roles': typeof AppPeopleRolesRoute
  '/people/users': typeof AppPeopleUsersRoute
  '/production/bom-explorer': typeof AppProductionBomExplorerRoute
  '/production/planning': typeof AppProductionPlanningRoute
  '/production/work-orders': typeof AppProductionWorkOrdersRoute
  '/reports/dealer-statement': typeof AppReportsDealerStatementRoute
  '/reports/item-sales-cost': typeof AppReportsItemSalesCostRoute
  '/reports/payment-expense-ledger': typeof AppReportsPaymentExpenseLedgerRoute
  '/reports/product-stock-sales-cost': typeof AppReportsProductStockSalesCostRoute
  '/reports/supplier-balances': typeof AppReportsSupplierBalancesRoute
  '/sales/credit-notes': typeof AppSalesCreditNotesRoute
  '/sales/dealers': typeof AppSalesDealersRouteWithChildren
  '/sales/deliveries': typeof AppSalesDeliveriesRoute
  '/sales/invoices': typeof AppSalesInvoicesRoute
  '/sales/orders': typeof AppSalesOrdersRoute
  '/sales/payments': typeof AppSalesPaymentsRoute
  '/sales/returns': typeof AppSalesReturnsRoute
  '/settings/branches': typeof AppSettingsBranchesRoute
  '/settings/brands': typeof AppSettingsBrandsRoute
  '/settings/categories': typeof AppSettingsCategoriesRoute
  '/settings/dealer-areas': typeof AppSettingsDealerAreasRoute
  '/settings/import-export': typeof AppSettingsImportExportRoute
  '/settings/master-data': typeof AppSettingsMasterDataRoute
  '/settings/opening-balances': typeof AppSettingsOpeningBalancesRoute
  '/settings/tax-rates': typeof AppSettingsTaxRatesRoute
  '/settings/units': typeof AppSettingsUnitsRoute
  '/workforce/attendance': typeof AppWorkforceAttendanceRoute
  '/workforce/employees': typeof AppWorkforceEmployeesRouteWithChildren
  '/workforce/payroll': typeof AppWorkforcePayrollRoute
  '/catalog': typeof AppCatalogIndexRoute
  '/inventory': typeof AppInventoryIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/catalog/products/$productId': typeof AppCatalogProductsProductIdRoute
  '/finance/reports/ar-aging': typeof AppFinanceReportsArAgingRoute
  '/finance/reports/balance-sheet': typeof AppFinanceReportsBalanceSheetRoute
  '/finance/reports/cash-flow': typeof AppFinanceReportsCashFlowRoute
  '/finance/reports/income-statement': typeof AppFinanceReportsIncomeStatementRoute
  '/finance/reports/trial-balance': typeof AppFinanceReportsTrialBalanceRoute
  '/sales/dealers/$dealerId': typeof AppSalesDealersDealerIdRoute
  '/workforce/employees/$employeeId': typeof AppWorkforceEmployeesEmployeeIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/analysis': typeof AppAnalysisRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/pricing': typeof AppPricingRoute
  '/_app/reports': typeof AppReportsRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/catalog/bom': typeof AppCatalogBomRoute
  '/_app/finance/accounts': typeof AppFinanceAccountsRoute
  '/_app/finance/expenses': typeof AppFinanceExpensesRoute
  '/_app/finance/fx': typeof AppFinanceFxRoute
  '/_app/finance/gl': typeof AppFinanceGlRoute
  '/_app/finance/loans': typeof AppFinanceLoansRoute
  '/_app/finance/payables': typeof AppFinancePayablesRoute
  '/_app/imports/lc': typeof AppImportsLcRoute
  '/_app/imports/purchase-orders': typeof AppImportsPurchaseOrdersRoute
  '/_app/imports/shipments': typeof AppImportsShipmentsRoute
  '/_app/imports/suppliers': typeof AppImportsSuppliersRoute
  '/_app/inventory/transfers': typeof AppInventoryTransfersRoute
  '/_app/inventory/warehouses': typeof AppInventoryWarehousesRoute
  '/_app/people/roles': typeof AppPeopleRolesRoute
  '/_app/people/users': typeof AppPeopleUsersRoute
  '/_app/production/bom-explorer': typeof AppProductionBomExplorerRoute
  '/_app/production/planning': typeof AppProductionPlanningRoute
  '/_app/production/work-orders': typeof AppProductionWorkOrdersRoute
  '/_app/reports/dealer-statement': typeof AppReportsDealerStatementRoute
  '/_app/reports/item-sales-cost': typeof AppReportsItemSalesCostRoute
  '/_app/reports/payment-expense-ledger': typeof AppReportsPaymentExpenseLedgerRoute
  '/_app/reports/product-stock-sales-cost': typeof AppReportsProductStockSalesCostRoute
  '/_app/reports/supplier-balances': typeof AppReportsSupplierBalancesRoute
  '/_app/sales/credit-notes': typeof AppSalesCreditNotesRoute
  '/_app/sales/dealers': typeof AppSalesDealersRouteWithChildren
  '/_app/sales/deliveries': typeof AppSalesDeliveriesRoute
  '/_app/sales/invoices': typeof AppSalesInvoicesRoute
  '/_app/sales/orders': typeof AppSalesOrdersRoute
  '/_app/sales/payments': typeof AppSalesPaymentsRoute
  '/_app/sales/returns': typeof AppSalesReturnsRoute
  '/_app/settings/branches': typeof AppSettingsBranchesRoute
  '/_app/settings/brands': typeof AppSettingsBrandsRoute
  '/_app/settings/categories': typeof AppSettingsCategoriesRoute
  '/_app/settings/dealer-areas': typeof AppSettingsDealerAreasRoute
  '/_app/settings/import-export': typeof AppSettingsImportExportRoute
  '/_app/settings/master-data': typeof AppSettingsMasterDataRoute
  '/_app/settings/opening-balances': typeof AppSettingsOpeningBalancesRoute
  '/_app/settings/tax-rates': typeof AppSettingsTaxRatesRoute
  '/_app/settings/units': typeof AppSettingsUnitsRoute
  '/_app/workforce/attendance': typeof AppWorkforceAttendanceRoute
  '/_app/workforce/employees': typeof AppWorkforceEmployeesRouteWithChildren
  '/_app/workforce/payroll': typeof AppWorkforcePayrollRoute
  '/_app/catalog/': typeof AppCatalogIndexRoute
  '/_app/inventory/': typeof AppInventoryIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/catalog/products/$productId': typeof AppCatalogProductsProductIdRoute
  '/_app/finance/reports/ar-aging': typeof AppFinanceReportsArAgingRoute
  '/_app/finance/reports/balance-sheet': typeof AppFinanceReportsBalanceSheetRoute
  '/_app/finance/reports/cash-flow': typeof AppFinanceReportsCashFlowRoute
  '/_app/finance/reports/income-statement': typeof AppFinanceReportsIncomeStatementRoute
  '/_app/finance/reports/trial-balance': typeof AppFinanceReportsTrialBalanceRoute
  '/_app/sales/dealers/$dealerId': typeof AppSalesDealersDealerIdRoute
  '/_app/workforce/employees/$employeeId': typeof AppWorkforceEmployeesEmployeeIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/analysis'
    | '/audit'
    | '/notifications'
    | '/pricing'
    | '/reports'
    | '/settings'
    | '/catalog/bom'
    | '/finance/accounts'
    | '/finance/expenses'
    | '/finance/fx'
    | '/finance/gl'
    | '/finance/loans'
    | '/finance/payables'
    | '/imports/lc'
    | '/imports/purchase-orders'
    | '/imports/shipments'
    | '/imports/suppliers'
    | '/inventory/transfers'
    | '/inventory/warehouses'
    | '/people/roles'
    | '/people/users'
    | '/production/bom-explorer'
    | '/production/planning'
    | '/production/work-orders'
    | '/reports/dealer-statement'
    | '/reports/item-sales-cost'
    | '/reports/payment-expense-ledger'
    | '/reports/product-stock-sales-cost'
    | '/reports/supplier-balances'
    | '/sales/credit-notes'
    | '/sales/dealers'
    | '/sales/deliveries'
    | '/sales/invoices'
    | '/sales/orders'
    | '/sales/payments'
    | '/sales/returns'
    | '/settings/branches'
    | '/settings/brands'
    | '/settings/categories'
    | '/settings/dealer-areas'
    | '/settings/import-export'
    | '/settings/master-data'
    | '/settings/opening-balances'
    | '/settings/tax-rates'
    | '/settings/units'
    | '/workforce/attendance'
    | '/workforce/employees'
    | '/workforce/payroll'
    | '/catalog/'
    | '/inventory/'
    | '/reports/'
    | '/settings/'
    | '/catalog/products/$productId'
    | '/finance/reports/ar-aging'
    | '/finance/reports/balance-sheet'
    | '/finance/reports/cash-flow'
    | '/finance/reports/income-statement'
    | '/finance/reports/trial-balance'
    | '/sales/dealers/$dealerId'
    | '/workforce/employees/$employeeId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/analysis'
    | '/audit'
    | '/notifications'
    | '/pricing'
    | '/'
    | '/catalog/bom'
    | '/finance/accounts'
    | '/finance/expenses'
    | '/finance/fx'
    | '/finance/gl'
    | '/finance/loans'
    | '/finance/payables'
    | '/imports/lc'
    | '/imports/purchase-orders'
    | '/imports/shipments'
    | '/imports/suppliers'
    | '/inventory/transfers'
    | '/inventory/warehouses'
    | '/people/roles'
    | '/people/users'
    | '/production/bom-explorer'
    | '/production/planning'
    | '/production/work-orders'
    | '/reports/dealer-statement'
    | '/reports/item-sales-cost'
    | '/reports/payment-expense-ledger'
    | '/reports/product-stock-sales-cost'
    | '/reports/supplier-balances'
    | '/sales/credit-notes'
    | '/sales/dealers'
    | '/sales/deliveries'
    | '/sales/invoices'
    | '/sales/orders'
    | '/sales/payments'
    | '/sales/returns'
    | '/settings/branches'
    | '/settings/brands'
    | '/settings/categories'
    | '/settings/dealer-areas'
    | '/settings/import-export'
    | '/settings/master-data'
    | '/settings/opening-balances'
    | '/settings/tax-rates'
    | '/settings/units'
    | '/workforce/attendance'
    | '/workforce/employees'
    | '/workforce/payroll'
    | '/catalog'
    | '/inventory'
    | '/reports'
    | '/settings'
    | '/catalog/products/$productId'
    | '/finance/reports/ar-aging'
    | '/finance/reports/balance-sheet'
    | '/finance/reports/cash-flow'
    | '/finance/reports/income-statement'
    | '/finance/reports/trial-balance'
    | '/sales/dealers/$dealerId'
    | '/workforce/employees/$employeeId'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/analysis'
    | '/_app/audit'
    | '/_app/notifications'
    | '/_app/pricing'
    | '/_app/reports'
    | '/_app/settings'
    | '/_app/'
    | '/_app/catalog/bom'
    | '/_app/finance/accounts'
    | '/_app/finance/expenses'
    | '/_app/finance/fx'
    | '/_app/finance/gl'
    | '/_app/finance/loans'
    | '/_app/finance/payables'
    | '/_app/imports/lc'
    | '/_app/imports/purchase-orders'
    | '/_app/imports/shipments'
    | '/_app/imports/suppliers'
    | '/_app/inventory/transfers'
    | '/_app/inventory/warehouses'
    | '/_app/people/roles'
    | '/_app/people/users'
    | '/_app/production/bom-explorer'
    | '/_app/production/planning'
    | '/_app/production/work-orders'
    | '/_app/reports/dealer-statement'
    | '/_app/reports/item-sales-cost'
    | '/_app/reports/payment-expense-ledger'
    | '/_app/reports/product-stock-sales-cost'
    | '/_app/reports/supplier-balances'
    | '/_app/sales/credit-notes'
    | '/_app/sales/dealers'
    | '/_app/sales/deliveries'
    | '/_app/sales/invoices'
    | '/_app/sales/orders'
    | '/_app/sales/payments'
    | '/_app/sales/returns'
    | '/_app/settings/branches'
    | '/_app/settings/brands'
    | '/_app/settings/categories'
    | '/_app/settings/dealer-areas'
    | '/_app/settings/import-export'
    | '/_app/settings/master-data'
    | '/_app/settings/opening-balances'
    | '/_app/settings/tax-rates'
    | '/_app/settings/units'
    | '/_app/workforce/attendance'
    | '/_app/workforce/employees'
    | '/_app/workforce/payroll'
    | '/_app/catalog/'
    | '/_app/inventory/'
    | '/_app/reports/'
    | '/_app/settings/'
    | '/_app/catalog/products/$productId'
    | '/_app/finance/reports/ar-aging'
    | '/_app/finance/reports/balance-sheet'
    | '/_app/finance/reports/cash-flow'
    | '/_app/finance/reports/income-statement'
    | '/_app/finance/reports/trial-balance'
    | '/_app/sales/dealers/$dealerId'
    | '/_app/workforce/employees/$employeeId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pricing': {
      id: '/_app/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof AppPricingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analysis': {
      id: '/_app/analysis'
      path: '/analysis'
      fullPath: '/analysis'
      preLoaderRoute: typeof AppAnalysisRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppReportsRoute
    }
    '/_app/inventory/': {
      id: '/_app/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof AppInventoryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/': {
      id: '/_app/catalog/'
      path: '/catalog'
      fullPath: '/catalog/'
      preLoaderRoute: typeof AppCatalogIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workforce/payroll': {
      id: '/_app/workforce/payroll'
      path: '/workforce/payroll'
      fullPath: '/workforce/payroll'
      preLoaderRoute: typeof AppWorkforcePayrollRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workforce/employees': {
      id: '/_app/workforce/employees'
      path: '/workforce/employees'
      fullPath: '/workforce/employees'
      preLoaderRoute: typeof AppWorkforceEmployeesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workforce/attendance': {
      id: '/_app/workforce/attendance'
      path: '/workforce/attendance'
      fullPath: '/workforce/attendance'
      preLoaderRoute: typeof AppWorkforceAttendanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/units': {
      id: '/_app/settings/units'
      path: '/units'
      fullPath: '/settings/units'
      preLoaderRoute: typeof AppSettingsUnitsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/tax-rates': {
      id: '/_app/settings/tax-rates'
      path: '/tax-rates'
      fullPath: '/settings/tax-rates'
      preLoaderRoute: typeof AppSettingsTaxRatesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/opening-balances': {
      id: '/_app/settings/opening-balances'
      path: '/opening-balances'
      fullPath: '/settings/opening-balances'
      preLoaderRoute: typeof AppSettingsOpeningBalancesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/master-data': {
      id: '/_app/settings/master-data'
      path: '/master-data'
      fullPath: '/settings/master-data'
      preLoaderRoute: typeof AppSettingsMasterDataRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/import-export': {
      id: '/_app/settings/import-export'
      path: '/import-export'
      fullPath: '/settings/import-export'
      preLoaderRoute: typeof AppSettingsImportExportRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/dealer-areas': {
      id: '/_app/settings/dealer-areas'
      path: '/dealer-areas'
      fullPath: '/settings/dealer-areas'
      preLoaderRoute: typeof AppSettingsDealerAreasRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/categories': {
      id: '/_app/settings/categories'
      path: '/categories'
      fullPath: '/settings/categories'
      preLoaderRoute: typeof AppSettingsCategoriesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/brands': {
      id: '/_app/settings/brands'
      path: '/brands'
      fullPath: '/settings/brands'
      preLoaderRoute: typeof AppSettingsBrandsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/branches': {
      id: '/_app/settings/branches'
      path: '/branches'
      fullPath: '/settings/branches'
      preLoaderRoute: typeof AppSettingsBranchesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/sales/returns': {
      id: '/_app/sales/returns'
      path: '/sales/returns'
      fullPath: '/sales/returns'
      preLoaderRoute: typeof AppSalesReturnsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/payments': {
      id: '/_app/sales/payments'
      path: '/sales/payments'
      fullPath: '/sales/payments'
      preLoaderRoute: typeof AppSalesPaymentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/orders': {
      id: '/_app/sales/orders'
      path: '/sales/orders'
      fullPath: '/sales/orders'
      preLoaderRoute: typeof AppSalesOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/invoices': {
      id: '/_app/sales/invoices'
      path: '/sales/invoices'
      fullPath: '/sales/invoices'
      preLoaderRoute: typeof AppSalesInvoicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/deliveries': {
      id: '/_app/sales/deliveries'
      path: '/sales/deliveries'
      fullPath: '/sales/deliveries'
      preLoaderRoute: typeof AppSalesDeliveriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/dealers': {
      id: '/_app/sales/dealers'
      path: '/sales/dealers'
      fullPath: '/sales/dealers'
      preLoaderRoute: typeof AppSalesDealersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/credit-notes': {
      id: '/_app/sales/credit-notes'
      path: '/sales/credit-notes'
      fullPath: '/sales/credit-notes'
      preLoaderRoute: typeof AppSalesCreditNotesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/supplier-balances': {
      id: '/_app/reports/supplier-balances'
      path: '/supplier-balances'
      fullPath: '/reports/supplier-balances'
      preLoaderRoute: typeof AppReportsSupplierBalancesRouteImport
      parentRoute: typeof AppReportsRoute
    }
    '/_app/reports/product-stock-sales-cost': {
      id: '/_app/reports/product-stock-sales-cost'
      path: '/product-stock-sales-cost'
      fullPath: '/reports/product-stock-sales-cost'
      preLoaderRoute: typeof AppReportsProductStockSalesCostRouteImport
      parentRoute: typeof AppReportsRoute
    }
    '/_app/reports/payment-expense-ledger': {
      id: '/_app/reports/payment-expense-ledger'
      path: '/payment-expense-ledger'
      fullPath: '/reports/payment-expense-ledger'
      preLoaderRoute: typeof AppReportsPaymentExpenseLedgerRouteImport
      parentRoute: typeof AppReportsRoute
    }
    '/_app/reports/item-sales-cost': {
      id: '/_app/reports/item-sales-cost'
      path: '/item-sales-cost'
      fullPath: '/reports/item-sales-cost'
      preLoaderRoute: typeof AppReportsItemSalesCostRouteImport
      parentRoute: typeof AppReportsRoute
    }
    '/_app/reports/dealer-statement': {
      id: '/_app/reports/dealer-statement'
      path: '/dealer-statement'
      fullPath: '/reports/dealer-statement'
      preLoaderRoute: typeof AppReportsDealerStatementRouteImport
      parentRoute: typeof AppReportsRoute
    }
    '/_app/production/work-orders': {
      id: '/_app/production/work-orders'
      path: '/production/work-orders'
      fullPath: '/production/work-orders'
      preLoaderRoute: typeof AppProductionWorkOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/production/planning': {
      id: '/_app/production/planning'
      path: '/production/planning'
      fullPath: '/production/planning'
      preLoaderRoute: typeof AppProductionPlanningRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/production/bom-explorer': {
      id: '/_app/production/bom-explorer'
      path: '/production/bom-explorer'
      fullPath: '/production/bom-explorer'
      preLoaderRoute: typeof AppProductionBomExplorerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/people/users': {
      id: '/_app/people/users'
      path: '/people/users'
      fullPath: '/people/users'
      preLoaderRoute: typeof AppPeopleUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/people/roles': {
      id: '/_app/people/roles'
      path: '/people/roles'
      fullPath: '/people/roles'
      preLoaderRoute: typeof AppPeopleRolesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/warehouses': {
      id: '/_app/inventory/warehouses'
      path: '/inventory/warehouses'
      fullPath: '/inventory/warehouses'
      preLoaderRoute: typeof AppInventoryWarehousesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/transfers': {
      id: '/_app/inventory/transfers'
      path: '/inventory/transfers'
      fullPath: '/inventory/transfers'
      preLoaderRoute: typeof AppInventoryTransfersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports/suppliers': {
      id: '/_app/imports/suppliers'
      path: '/imports/suppliers'
      fullPath: '/imports/suppliers'
      preLoaderRoute: typeof AppImportsSuppliersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports/shipments': {
      id: '/_app/imports/shipments'
      path: '/imports/shipments'
      fullPath: '/imports/shipments'
      preLoaderRoute: typeof AppImportsShipmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports/purchase-orders': {
      id: '/_app/imports/purchase-orders'
      path: '/imports/purchase-orders'
      fullPath: '/imports/purchase-orders'
      preLoaderRoute: typeof AppImportsPurchaseOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports/lc': {
      id: '/_app/imports/lc'
      path: '/imports/lc'
      fullPath: '/imports/lc'
      preLoaderRoute: typeof AppImportsLcRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/payables': {
      id: '/_app/finance/payables'
      path: '/finance/payables'
      fullPath: '/finance/payables'
      preLoaderRoute: typeof AppFinancePayablesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/loans': {
      id: '/_app/finance/loans'
      path: '/finance/loans'
      fullPath: '/finance/loans'
      preLoaderRoute: typeof AppFinanceLoansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/gl': {
      id: '/_app/finance/gl'
      path: '/finance/gl'
      fullPath: '/finance/gl'
      preLoaderRoute: typeof AppFinanceGlRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/fx': {
      id: '/_app/finance/fx'
      path: '/finance/fx'
      fullPath: '/finance/fx'
      preLoaderRoute: typeof AppFinanceFxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/expenses': {
      id: '/_app/finance/expenses'
      path: '/finance/expenses'
      fullPath: '/finance/expenses'
      preLoaderRoute: typeof AppFinanceExpensesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/accounts': {
      id: '/_app/finance/accounts'
      path: '/finance/accounts'
      fullPath: '/finance/accounts'
      preLoaderRoute: typeof AppFinanceAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/bom': {
      id: '/_app/catalog/bom'
      path: '/catalog/bom'
      fullPath: '/catalog/bom'
      preLoaderRoute: typeof AppCatalogBomRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workforce/employees/$employeeId': {
      id: '/_app/workforce/employees/$employeeId'
      path: '/$employeeId'
      fullPath: '/workforce/employees/$employeeId'
      preLoaderRoute: typeof AppWorkforceEmployeesEmployeeIdRouteImport
      parentRoute: typeof AppWorkforceEmployeesRoute
    }
    '/_app/sales/dealers/$dealerId': {
      id: '/_app/sales/dealers/$dealerId'
      path: '/$dealerId'
      fullPath: '/sales/dealers/$dealerId'
      preLoaderRoute: typeof AppSalesDealersDealerIdRouteImport
      parentRoute: typeof AppSalesDealersRoute
    }
    '/_app/finance/reports/trial-balance': {
      id: '/_app/finance/reports/trial-balance'
      path: '/finance/reports/trial-balance'
      fullPath: '/finance/reports/trial-balance'
      preLoaderRoute: typeof AppFinanceReportsTrialBalanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/reports/income-statement': {
      id: '/_app/finance/reports/income-statement'
      path: '/finance/reports/income-statement'
      fullPath: '/finance/reports/income-statement'
      preLoaderRoute: typeof AppFinanceReportsIncomeStatementRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/reports/cash-flow': {
      id: '/_app/finance/reports/cash-flow'
      path: '/finance/reports/cash-flow'
      fullPath: '/finance/reports/cash-flow'
      preLoaderRoute: typeof AppFinanceReportsCashFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/reports/balance-sheet': {
      id: '/_app/finance/reports/balance-sheet'
      path: '/finance/reports/balance-sheet'
      fullPath: '/finance/reports/balance-sheet'
      preLoaderRoute: typeof AppFinanceReportsBalanceSheetRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/reports/ar-aging': {
      id: '/_app/finance/reports/ar-aging'
      path: '/finance/reports/ar-aging'
      fullPath: '/finance/reports/ar-aging'
      preLoaderRoute: typeof AppFinanceReportsArAgingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/products/$productId': {
      id: '/_app/catalog/products/$productId'
      path: '/catalog/products/$productId'
      fullPath: '/catalog/products/$productId'
      preLoaderRoute: typeof AppCatalogProductsProductIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppReportsRouteChildren {
  AppReportsDealerStatementRoute: typeof AppReportsDealerStatementRoute
  AppReportsItemSalesCostRoute: typeof AppReportsItemSalesCostRoute
  AppReportsPaymentExpenseLedgerRoute: typeof AppReportsPaymentExpenseLedgerRoute
  AppReportsProductStockSalesCostRoute: typeof AppReportsProductStockSalesCostRoute
  AppReportsSupplierBalancesRoute: typeof AppReportsSupplierBalancesRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
}

const AppReportsRouteChildren: AppReportsRouteChildren = {
  AppReportsDealerStatementRoute: AppReportsDealerStatementRoute,
  AppReportsItemSalesCostRoute: AppReportsItemSalesCostRoute,
  AppReportsPaymentExpenseLedgerRoute: AppReportsPaymentExpenseLedgerRoute,
  AppReportsProductStockSalesCostRoute: AppReportsProductStockSalesCostRoute,
  AppReportsSupplierBalancesRoute: AppReportsSupplierBalancesRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
}

const AppReportsRouteWithChildren = AppReportsRoute._addFileChildren(
  AppReportsRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsBranchesRoute: typeof AppSettingsBranchesRoute
  AppSettingsBrandsRoute: typeof AppSettingsBrandsRoute
  AppSettingsCategoriesRoute: typeof AppSettingsCategoriesRoute
  AppSettingsDealerAreasRoute: typeof AppSettingsDealerAreasRoute
  AppSettingsImportExportRoute: typeof AppSettingsImportExportRoute
  AppSettingsMasterDataRoute: typeof AppSettingsMasterDataRoute
  AppSettingsOpeningBalancesRoute: typeof AppSettingsOpeningBalancesRoute
  AppSettingsTaxRatesRoute: typeof AppSettingsTaxRatesRoute
  AppSettingsUnitsRoute: typeof AppSettingsUnitsRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsBranchesRoute: AppSettingsBranchesRoute,
  AppSettingsBrandsRoute: AppSettingsBrandsRoute,
  AppSettingsCategoriesRoute: AppSettingsCategoriesRoute,
  AppSettingsDealerAreasRoute: AppSettingsDealerAreasRoute,
  AppSettingsImportExportRoute: AppSettingsImportExportRoute,
  AppSettingsMasterDataRoute: AppSettingsMasterDataRoute,
  AppSettingsOpeningBalancesRoute: AppSettingsOpeningBalancesRoute,
  AppSettingsTaxRatesRoute: AppSettingsTaxRatesRoute,
  AppSettingsUnitsRoute: AppSettingsUnitsRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppSalesDealersRouteChildren {
  AppSalesDealersDealerIdRoute: typeof AppSalesDealersDealerIdRoute
}

const AppSalesDealersRouteChildren: AppSalesDealersRouteChildren = {
  AppSalesDealersDealerIdRoute: AppSalesDealersDealerIdRoute,
}

const AppSalesDealersRouteWithChildren = AppSalesDealersRoute._addFileChildren(
  AppSalesDealersRouteChildren,
)

interface AppWorkforceEmployeesRouteChildren {
  AppWorkforceEmployeesEmployeeIdRoute: typeof AppWorkforceEmployeesEmployeeIdRoute
}

const AppWorkforceEmployeesRouteChildren: AppWorkforceEmployeesRouteChildren = {
  AppWorkforceEmployeesEmployeeIdRoute: AppWorkforceEmployeesEmployeeIdRoute,
}

const AppWorkforceEmployeesRouteWithChildren =
  AppWorkforceEmployeesRoute._addFileChildren(
    AppWorkforceEmployeesRouteChildren,
  )

interface AppRouteChildren {
  AppAnalysisRoute: typeof AppAnalysisRoute
  AppAuditRoute: typeof AppAuditRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppPricingRoute: typeof AppPricingRoute
  AppReportsRoute: typeof AppReportsRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppCatalogBomRoute: typeof AppCatalogBomRoute
  AppFinanceAccountsRoute: typeof AppFinanceAccountsRoute
  AppFinanceExpensesRoute: typeof AppFinanceExpensesRoute
  AppFinanceFxRoute: typeof AppFinanceFxRoute
  AppFinanceGlRoute: typeof AppFinanceGlRoute
  AppFinanceLoansRoute: typeof AppFinanceLoansRoute
  AppFinancePayablesRoute: typeof AppFinancePayablesRoute
  AppImportsLcRoute: typeof AppImportsLcRoute
  AppImportsPurchaseOrdersRoute: typeof AppImportsPurchaseOrdersRoute
  AppImportsShipmentsRoute: typeof AppImportsShipmentsRoute
  AppImportsSuppliersRoute: typeof AppImportsSuppliersRoute
  AppInventoryTransfersRoute: typeof AppInventoryTransfersRoute
  AppInventoryWarehousesRoute: typeof AppInventoryWarehousesRoute
  AppPeopleRolesRoute: typeof AppPeopleRolesRoute
  AppPeopleUsersRoute: typeof AppPeopleUsersRoute
  AppProductionBomExplorerRoute: typeof AppProductionBomExplorerRoute
  AppProductionPlanningRoute: typeof AppProductionPlanningRoute
  AppProductionWorkOrdersRoute: typeof AppProductionWorkOrdersRoute
  AppSalesCreditNotesRoute: typeof AppSalesCreditNotesRoute
  AppSalesDealersRoute: typeof AppSalesDealersRouteWithChildren
  AppSalesDeliveriesRoute: typeof AppSalesDeliveriesRoute
  AppSalesInvoicesRoute: typeof AppSalesInvoicesRoute
  AppSalesOrdersRoute: typeof AppSalesOrdersRoute
  AppSalesPaymentsRoute: typeof AppSalesPaymentsRoute
  AppSalesReturnsRoute: typeof AppSalesReturnsRoute
  AppWorkforceAttendanceRoute: typeof AppWorkforceAttendanceRoute
  AppWorkforceEmployeesRoute: typeof AppWorkforceEmployeesRouteWithChildren
  AppWorkforcePayrollRoute: typeof AppWorkforcePayrollRoute
  AppCatalogIndexRoute: typeof AppCatalogIndexRoute
  AppInventoryIndexRoute: typeof AppInventoryIndexRoute
  AppCatalogProductsProductIdRoute: typeof AppCatalogProductsProductIdRoute
  AppFinanceReportsArAgingRoute: typeof AppFinanceReportsArAgingRoute
  AppFinanceReportsBalanceSheetRoute: typeof AppFinanceReportsBalanceSheetRoute
  AppFinanceReportsCashFlowRoute: typeof AppFinanceReportsCashFlowRoute
  AppFinanceReportsIncomeStatementRoute: typeof AppFinanceReportsIncomeStatementRoute
  AppFinanceReportsTrialBalanceRoute: typeof AppFinanceReportsTrialBalanceRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAnalysisRoute: AppAnalysisRoute,
  AppAuditRoute: AppAuditRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppPricingRoute: AppPricingRoute,
  AppReportsRoute: AppReportsRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppCatalogBomRoute: AppCatalogBomRoute,
  AppFinanceAccountsRoute: AppFinanceAccountsRoute,
  AppFinanceExpensesRoute: AppFinanceExpensesRoute,
  AppFinanceFxRoute: AppFinanceFxRoute,
  AppFinanceGlRoute: AppFinanceGlRoute,
  AppFinanceLoansRoute: AppFinanceLoansRoute,
  AppFinancePayablesRoute: AppFinancePayablesRoute,
  AppImportsLcRoute: AppImportsLcRoute,
  AppImportsPurchaseOrdersRoute: AppImportsPurchaseOrdersRoute,
  AppImportsShipmentsRoute: AppImportsShipmentsRoute,
  AppImportsSuppliersRoute: AppImportsSuppliersRoute,
  AppInventoryTransfersRoute: AppInventoryTransfersRoute,
  AppInventoryWarehousesRoute: AppInventoryWarehousesRoute,
  AppPeopleRolesRoute: AppPeopleRolesRoute,
  AppPeopleUsersRoute: AppPeopleUsersRoute,
  AppProductionBomExplorerRoute: AppProductionBomExplorerRoute,
  AppProductionPlanningRoute: AppProductionPlanningRoute,
  AppProductionWorkOrdersRoute: AppProductionWorkOrdersRoute,
  AppSalesCreditNotesRoute: AppSalesCreditNotesRoute,
  AppSalesDealersRoute: AppSalesDealersRouteWithChildren,
  AppSalesDeliveriesRoute: AppSalesDeliveriesRoute,
  AppSalesInvoicesRoute: AppSalesInvoicesRoute,
  AppSalesOrdersRoute: AppSalesOrdersRoute,
  AppSalesPaymentsRoute: AppSalesPaymentsRoute,
  AppSalesReturnsRoute: AppSalesReturnsRoute,
  AppWorkforceAttendanceRoute: AppWorkforceAttendanceRoute,
  AppWorkforceEmployeesRoute: AppWorkforceEmployeesRouteWithChildren,
  AppWorkforcePayrollRoute: AppWorkforcePayrollRoute,
  AppCatalogIndexRoute: AppCatalogIndexRoute,
  AppInventoryIndexRoute: AppInventoryIndexRoute,
  AppCatalogProductsProductIdRoute: AppCatalogProductsProductIdRoute,
  AppFinanceReportsArAgingRoute: AppFinanceReportsArAgingRoute,
  AppFinanceReportsBalanceSheetRoute: AppFinanceReportsBalanceSheetRoute,
  AppFinanceReportsCashFlowRoute: AppFinanceReportsCashFlowRoute,
  AppFinanceReportsIncomeStatementRoute: AppFinanceReportsIncomeStatementRoute,
  AppFinanceReportsTrialBalanceRoute: AppFinanceReportsTrialBalanceRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
